
import { useState } from "react";
import toast from "react-hot-toast";

export const ErrorDetailModal = ({ message, onClose }) => {
  if (!message) return null;

  return (
    <div
      className="fixed inset-0 bg-black/45 flex items-center justify-center z-[9999]"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl p-6 max-w-[560px] w-[90%] shadow-2xl relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-4 bg-transparent border-none cursor-pointer text-[22px] text-gray-400 leading-none p-0"
        >
          ×
        </button>

        <div className="flex items-center gap-2 mb-4">
          <div className="w-[8px] h-[8px] rounded-full bg-red-500 shrink-0" />
          <span className="text-red-700 font-semibold text-[15px]">
            Error Details
          </span>
        </div>

        <div className="bg-red-50 border border-red-200 rounded-lg px-4 py-3 text-gray-700 text-[13px] leading-7 break-words max-h-80 overflow-y-auto font-mono">
          {message}
        </div>

        <button
          onClick={onClose}
          className="mt-4 px-5 py-2 bg-[#FF03F3] text-white border-none rounded-md cursor-pointer text-[13px] font-medium"
        >
          Close
        </button>
      </div>
    </div>
  );
};

const PREVIEW_LENGTH = 60;

const useSmartToast = () => {
  const [expandedToast, setExpandedToast] = useState(null);

  const extractErrorMessage = (error, fallback) =>
    error?.response?.data?.detail ||
    error?.response?.data?.message ||
    error?.message ||
    fallback;

  const showSmartToast = (message) => {
    const isLong = message && message.length > PREVIEW_LENGTH;
    const preview = isLong
      ? message.slice(0, PREVIEW_LENGTH).trim() + "…"
      : message;

    toast.custom(
      (t) => (
        <div className="bg-white border border-red-200 border-l-4 border-l-red-500 rounded-lg px-4 py-3 max-w-[380px] shadow-md flex flex-col gap-1.5 relative">
          <button
            onClick={() => toast.dismiss(t.id)}
            className="absolute top-2 right-2.5 bg-transparent border-none cursor-pointer text-lg text-gray-400 leading-none p-0"
          >
            ×
          </button>

          <div className="text-red-700 font-semibold text-[13px] pr-5">
            Error
          </div>

          <div className="text-gray-700 text-[13px] leading-6 pr-5">
            {preview}
          </div>

          {isLong && (
            <button
              onClick={() => {
                toast.dismiss(t.id);
                setExpandedToast(message);
              }}
              className="self-start bg-transparent border-none text-blue-500 cursor-pointer text-xs p-0 font-medium underline"
            >
              View more
            </button>
          )}
        </div>
      ),
      { duration: 6000 }
    );
  };

  return {
    expandedToast,
    closeExpandedToast: () => setExpandedToast(null),
    showSmartToast,
    extractErrorMessage,
  };
};

export default useSmartToast;